 export const CHORDS = {
  I: ['Db', 'F', 'Ab'],
  ii: ['Eb', 'Gb', 'Bb'],
  iii: ['C', 'F', 'Ab'],
  IV: ['Db', 'Gb', 'Bb'],
  V: ['C', 'Eb', 'Ab'],
  vi: ['Db', 'F', 'Bb'],
  'vii&#x26AC;': ['C', 'Eb', 'Gb'],
}

export const BASS = {
  I: ['Db3', 'Ab3'],
  ii: ['Eb3', 'Bb3'],
  iii: ['F3', 'C4'],
  IV: ['Gb3', 'Db4'],
  V: ['Ab2', 'Eb3'],
  vi: ['Bb2', 'F3'],
  'vii&#x26AC;': ['C3', 'Gb3'],
}


